export interface IChartData {
  name: string | Date;
  value: string | number;
}
